import { routeNames } from "../routeNames";
import statuses from "./myFlexiPlanStepStatuses";

const myFlexiPlanSteps = {
    device: {
        name: "Device",
        icon: "fa-mobile",
        routeName: routeNames.SELECT_DEVICE,
        status: statuses.required,
        selectedItem: null,
        categoryName: "Devices",
    },
    voice: {
        name: "Voice+SMS Plan",
        icon: "fa-envelope",
        routeName: routeNames.SELECT_VOICE,
        status: null,
        selectedItem: null,
        categoryName: "Voice",
    },
    data: {
        name: "Data Plan",
        icon: "fa-wifi",
        routeName: routeNames.SELECT_DATA,
        status: null,
        selectedItem: null,
        categoryName: "Data",
    },
    confirmPlanDetails: {
        name: "Plan Details",
        icon: "fa-pen",
        routeName: routeNames.CONFIRM_PLAN_DETAILS,
        status: null,
        selectedItem: null,
        categoryName: "ConfirmPlanDetails",
    },
    confirmOtp: {
        name: "Confirm Otp",
        icon: "fa-key",
        routeName: routeNames.CONFIRM_OTP,
        status: statuses.unavailable,
        selectedItem: null,
        categoryName: "ConfirmOTP",
    },
};

export default myFlexiPlanSteps;
